<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
      <el-form-item label="机构列表名称" prop="name">
        <el-input v-model="form.name" />
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" />
      </el-form-item>
    </el-form>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { parseTime } from '@/utils/index'
  import { addEnterpriseGroup, upDateEnterpriseGroup } from '@/api/enterPriseApi'
  export default defineComponent({
    name: 'EnterpriseListEdit',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: 500,
        title: '',
        form: {},
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入机构名称' }],
        },
      })
      // 打开
      const handleOpen = async (row) => {
        console.log(row)
        if (row) {
          state.title = '编辑'
          state.form = JSON.parse(JSON.stringify(row))
        } else {
          state.title = '新增'
        }
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const handleSave = async () => {
        try {
          state.form.meetingCode = props.meetingCode
          if (state.title === '新增') {
            await addEnterpriseGroup(state.form)
          } else {
            await upDateEnterpriseGroup(state.form)
          }

          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          emit('fetchData')
          handleClose()
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleDate,
        handleSave,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }

    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }

  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }

  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }

  .margin-top {
    margin-top: 20px;
  }
</style>
